
var dividerLess = {};
import genaration from '../../utils/classname';
export var dividerClass = genaration(dividerLess, 'divider');